import type { TestGroupingGroup } from '@vedalib/editor/lib/elements'
import { TestAnswerFeedbackType } from '@vedalib/editor/lib/elements'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { chainName, FieldArray, FieldSegmented, FieldSelect, FormField } from 'components/formKit'
import { useHiddenTestFeedback } from 'services/Branding/fieldConfigs/useFieldConfigs'
import { t } from 'services/Translation'
import { getEnumOption } from 'utils/enum'

import TestGroupingFormValueAddGroup from './TestGroupingFormValueAddGroup'
import TestGroupingFormValueProvider from './TestGroupingFormValueContext'
import TestGroupingFormValueItemGroup from './TestGroupingFormValueItemGroup'
import type { TestGroupingValueFormType } from './testGroupingTypes'

const ANSWER_FEEDBACK = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'answerFeedback',
  label: t('elements.testAnswerFeedback.form.answerFeedback'),
  defaultValue: true,
})

const DISPLAY_FEEDBACK = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'displayFeedback',
  label: t('elements.testAnswerFeedback.form.displayFeedback'),
  layout: 'horizontal',
  defaultValue: true,
})

const GENERAL_TYPE_FB = genElementValueField({
  as: FieldSelect<TestAnswerFeedbackType>,
  name: 'generalTypeFb',
  label: t('elements.testAnswerFeedback.form.generalTypeFb'),
  layout: 'horizontal',
  defaultValue: TestAnswerFeedbackType.validation,
  props: {
    options: [
      getEnumOption('TestFeedbackType', TestAnswerFeedbackType.validation),
      getEnumOption('TestFeedbackType', TestAnswerFeedbackType.info),
    ],
  },
  useConfigs: [useHiddenTestFeedback],
})

const RESULT = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'showResult',
  label: t('elements.testGrouping.form.showResult'),
  defaultValue: true,
})

const ITEMS = genElementValueField({
  as: FieldArray<TestGroupingGroup>,
  name: 'items',
  props: {
    RenderItem: TestGroupingFormValueItemGroup,
    RenderAdd: TestGroupingFormValueAddGroup,
    max: 10,
    min: 1,
  },
})

const TestGroupingForm: TestGroupingValueFormType = ({ name, setState }) => (
  <Padding bottom gap sides>
    <FormField config={chainName(name, ANSWER_FEEDBACK)} />
    <FormField config={chainName(name, DISPLAY_FEEDBACK)} />
    <FormField config={chainName(name, GENERAL_TYPE_FB)} />
    <FormField config={chainName(name, RESULT)} />
    <TestGroupingFormValueProvider setElementState={setState}>
      <FormField config={chainName(name, ITEMS)} />
    </TestGroupingFormValueProvider>
  </Padding>
)

export default TestGroupingForm
